export default {
  NOT_PRINTED: 'Belum Dicetak',
  PRINTED: 'Sudah Dicetak',
  SENT: 'Sudah Dikirim',
  RECEIVED: 'Sudah Diterima',
  PAID: 'Sudah Dibayar',
};
